import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Observable, take } from 'rxjs';
import {
  UserMenuComponent,
  AuthBasicData,
  UserAction,
  AuthService,
  apiRoutes,
} from '@t-llevo/auth';
import { NotificationService } from '@t-llevo/common-ui';
import {
  User,
  Environment,
  RequestParam,
  DEFAULT_HEADERS,
  LogoutRequest,
  LogoutResponse,
} from '@t-llevo/util';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    NgOptimizedImage,
    RouterLink,
    RouterLinkActive,
    UserMenuComponent,
    MatIconModule,
    MatButtonModule,
  ],
})
export class HeaderComponent implements OnInit {
  @Input({ required: true }) logoImg = '';
  @Input({ required: true }) canShow = false;

  userData$: Observable<AuthBasicData<User> | null>;
  authUserMenu: UserAction[] = [];

  constructor(
    private authSrv: AuthService,
    @Inject(Environment) private env: Environment,
    private router: Router,
    private notifSrv: NotificationService
  ) {
    this.userData$ = this.authSrv.sessionData$;
  }

  ngOnInit(): void {
    this.authUserMenu = [
      {
        title: 'Perfil',
        name: 'profile',
        description: 'Ver datos de usuario',
        icon: 'NONE',
        image: 'NONE',
      },
    ];
  }

  onActionDispached(ev: UserAction): void {
    if (ev.name === 'logout') {
      this.logout();
    } else if (ev.name === 'profile') {
      this.router.navigate(['/profile']);
    }
  }

  logout() {
    const token = this.authSrv.getAuthToken() ?? null;
    this.authSrv.localLogOut();
    if (token) {
      const params: RequestParam = {
        url: `${this.env.apiUrl}${apiRoutes.routeLogout}`,
        headers: { ...DEFAULT_HEADERS },
      };
      this.authSrv
        .logout<LogoutRequest, LogoutResponse>(
          params,
          { token },
          { token: true }
        )
        .pipe(take(1))
        .subscribe();
    }
  }
}
